import * as _ from 'lodash'
import { Variable, VArray, VBoolean, all } from 'alkali'
import { createExtractGroup, VGroup } from './extraction'
import StudyContext from './StudyContext'
import UpdateModel from './UpdateModel'
import { isValidGroup } from './extraction'
import { diffExtractGroups } from 'services/extract/util'
import { extractGroups, toExtractGroup } from 'services/extract/generate'
import { EGroup } from 'services/extract/types'

const VGroupArray = VArray.of(VGroup)

/**
 * UpdateModel for Group editing/management
 */
export default class GroupsModel implements UpdateModel {
	private readonly initial: EGroup[]
	readonly groups: VArray<VGroup>
	readonly diff: Variable
	readonly hasChanges: VBoolean
	readonly isValid: VBoolean
	readonly isSelfValid: VBoolean
	readonly canSubmit: VBoolean
	constructor(readonly study: StudyContext) {
		this.initial = study.groups.map(o => toExtractGroup(o))
		this.groups = new VGroupArray(this.study.groups.map(g => createExtractGroup(toExtractGroup(g))))
		this.diff = this.groups.to(current => this.getDiff(current, this.initial))
		this.hasChanges = this.diff.to(d => !!Object.values(d).flat().length)
		this.isSelfValid = all([this.groups, this.diff], (groups, { added, changed }) =>
			// check that the complete object is valid
			added.concat(changed).map(g => groups.find(e => e.id == g.id)).every(r => isValidGroup(r))
		)
		this.isValid = this.isSelfValid
	}

	private getDiff(current: EGroup[], initial: EGroup[]) {
		const removed = _.differenceBy(initial, current, g => g.id)
		const added = _.differenceBy(current, initial, g => g.id)
		const changed = _.without(current, ...added).filter(cur =>
			cur.existing && !_.isEmpty(diffExtractGroups(cur, cur.existing))
		)

		return {
			removed,
			added,
			changed
		}
	}

	addGroup() {
		this.groups.push(createExtractGroup())
	}

	generateUpdates(id: number) {
		const { removed, added, changed } = this.diff.valueOf()
		// removed??
		const groups = added.concat(changed)
		const map = _.transform(groups, (map, group: EGroup) => {
			const id = group.existing || group.id
			const studyGroup = this.study.groupsById[id]
			if (studyGroup) map[id] = [studyGroup]
		}, {})
		const updates = extractGroups(this.study.study, groups, map, { id })
		return { updates }
	}
}